/**
 * @module webdnn
 */
/** Don't Remove This comment block */
/**
 * Abstract buffer interface. Read/write transactions are regarded as asynchronous operation.
 *
 * @protected
 */
export class Buffer {
    constructor(byteLength, backend) {
        this.byteLength = byteLength;
        this.backend = backend;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/descriptor_runner/buffer/buffer.js
// module id = 15
// module chunks = 0